import { useNavigate } from "react-router";

import { Button } from "@design-system/Button/Button";
import { Card } from "@design-system/Card/Card";
import { Lottie } from "@design-system/Lottie/Lottie";

import { routes } from "./routes";

export const NotFound = () => {
  const navigate = useNavigate();

  const handleTakeMeHomeClick = () => {
    navigate(routes.portal.dashboard.$path());
  };

  return (
    <Card>
      <Card.Header>
        <Card.Header.Title>This page does not exist</Card.Header.Title>
      </Card.Header>
      <Card.Body>
        <Lottie lottie="error404" />
      </Card.Body>
      <Card.Footer>
        <Button variant="outlined" onClick={handleTakeMeHomeClick}>
          Take me home
        </Button>
      </Card.Footer>
    </Card>
  );
};
